import { showGuard } from '../guards';
import Analytics from '@/views/Dashboard/Shows/Analytics';
import EditShow from '@/views/Dashboard/Shows/EditShow';
import Episodes from '@/views/Dashboard/Shows/Episodes';
import Players from '@/views/Dashboard/Shows/Players';
import Settings from '@/views/Dashboard/Shows/Settings';
import SettingsBranding from '@/views/Dashboard/Shows/Settings/Branding';
import SettingsDirectories from '@/views/Dashboard/Shows/Settings/Directories';
import SettingsHosting from '@/views/Dashboard/Shows/Settings/Hosting';
import SettingsPlan from '@/views/Dashboard/Shows/Settings/Plans';
import SettingsPlayerSettings from '@/views/Dashboard/Shows/Settings/PlayerSettings';
import SettingsPodcast from '@/views/Dashboard/Shows/Settings/Podcast';
import SettingsSubscribeLinks from '@/views/Dashboard/Shows/Settings/SubscribeLinks';
import Shows from '@/views/Dashboard/Shows.vue';

export default [
    {
        path: 'shows',
        component: Shows,
        meta: {
            title: 'Shows',
        },
    },
    {
        path: 'shows/:hash',
        component: EditShow,
        children: [
            {
                path: '',
                component: Players,
                name: 'Players',
            },
            {
                path: 'episodes',
                component: Episodes,
                name: 'Episodes',
            },
            {
                path: 'analytics',
                component: Analytics,
                name: 'Analytics',
            },
            {
                path: 'settings',
                component: Settings,
                name: 'Settings',
                children: [
                    {
                        path: '',
                        component: SettingsPodcast,
                    },
                    {
                        path: 'hosting',
                        component: SettingsHosting,
                    },
                    {
                        path: 'branding',
                        component: SettingsBranding,
                    },
                    {
                        path: 'directories',
                        component: SettingsDirectories,
                    },
                    {
                        path: 'player-settings',
                        component: SettingsPlayerSettings,
                    },
                    {
                        path: 'subscribe-links',
                        component: SettingsSubscribeLinks,
                    },
                    {
                        path: 'plan',
                        component: SettingsPlan,
                    },
                ],
            },
        ],
        beforeEnter: showGuard,
    },
];
